module.exports = __webpack_public_path__ + "img/open-data-error-heavy-query.629a3f37.svg";